import type { FEEDBACK_CAMPAIGN_ORIGINS } from '@didaskill/domain/feedback-campaigns/constants';
import type { FeedbackCampaign } from '@didaskill/domain/feedback-campaigns/types';

import { HttpRepository } from '../httpRepository';

const BASE_USERS_URI = '/api/v1/users/tutors';

const e = encodeURIComponent;

export class TutorsRepository extends HttpRepository {
  /**
   * Get the tutor feedback campaigns.
   *
   * @returns List of feedback campaigns.
   */
  async getTutorFeedbackCampaigns(): Promise<FeedbackCampaign[]> {
    const { body } = await this.http.get(`${BASE_USERS_URI}/me/feedback-campaigns`);

    return body;
  }

  /**
   * Post answer for a feedback campaign.
   *
   * @param campaignId - Campaign Id.
   * @param rating - Rating of the feedback.
   * @param comment - Comment for the feedback.
   * @returns List of feedback campaigns.
   */
  async postTutorFeedbackCampaignAnswers(
    campaignId: string,
    origin: FEEDBACK_CAMPAIGN_ORIGINS,
    rating?: number,
    comment?: string,
    externalAnswerId?: string,
    context?: Record<string, string>,
  ): Promise<FeedbackCampaign[]> {
    const { body } = await this.http
      .post(`${BASE_USERS_URI}/me/feedback-campaigns/${e(campaignId)}/answers`)
      .send({
        rating,
        comment,
        externalAnswerId,
        origin,
        context,
      });

    return body;
  }
}
